import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "template"]

    connect() {
        // Initialize Choices.js for existing selects
        this.initializeChoices()
    }

    addAssociation(event) {
        event.preventDefault()
        const content = this.templateTarget.content.cloneNode(true)
        const timestamp = new Date().getTime()

        // Update field names with unique timestamp
        content.querySelectorAll('input, select, textarea').forEach(field => {
            if (field.name) {
                field.name = field.name.replace(/NEW_RECORD/g, timestamp)
            }
            if (field.id) {
                field.id = field.id.replace(/NEW_RECORD/g, timestamp)
            }
        })

        this.containerTarget.appendChild(content)

        // Initialize Choices.js for the new select (if any)
        const newRow = this.containerTarget.lastElementChild
        const selectElement = newRow?.querySelector('select')
        if (selectElement && window.Choices) {
            new window.Choices(selectElement, window.choicesConfigDefault)
        }
    }

    removeAssociation(event) {
        event.preventDefault()
        const row = event.target.closest('.nested-fields')

        if (!row) {
            console.error('Could not find .nested-fields element')
            return
        }

        const destroyField = row.querySelector('input[name*="_destroy"]')

        if (row.dataset.newRecord === 'true') {
            // Just remove new records
            row.remove()
        } else {
            // Mark existing records for destruction
            if (destroyField) {
                destroyField.value = '1'
            }
            row.style.display = 'none'
        }
    }

    markForDestruction(event) {
        event.preventDefault()
        const button = event.target.closest('button')
        const card = button.closest('.card')

        if (!card) {
            console.error('Could not find .card element')
            return
        }

        const destroyField = card.querySelector('input[name*="_destroy"]')

        if (!destroyField) {
            console.error('Could not find destroy field in card:', card)
            return
        }

        destroyField.value = '1'

        card.style.opacity = '0.5'
        card.style.pointerEvents = 'none'

        // Replace button with badge
        if (button) {
            button.outerHTML = '<span class="badge bg-danger w-100">Будет удалено</span>'
        }
    }

    initializeChoices() {
        if (!window.Choices) return

        this.containerTarget.querySelectorAll('select').forEach(select => {
            if (!select.choices) {
                new window.Choices(select, window.choicesConfigDefault)
            }
        })
    }
}
